import * as React from "react";
import { useDispatch, useSelector } from "@teamprevent/admin-redux";

import { DropdownOption } from "@teamprevent/common/questionnaires/model";

import { ApplicationState } from "../../applicationState";

import { getUserDisplayName } from "./model";

import { AdminUser, loadAdminUsers } from ".";

export const useAdminUserOptions = () => {
    const dispatch = useDispatch();

    const [adminUserOptions, setAdminUserOptions] = React.useState<DropdownOption[]>([]);

    const adminUsers = useSelector((state: ApplicationState) => state.adminUsers);

    React.useEffect(() => {
        if (adminUsers?.length === 0) {
            dispatch(loadAdminUsers());
        }
    }, []);

    React.useEffect(() => {
        if (adminUsers?.length > 0) {
            const options = mapAdminUsersToOptions(adminUsers);
            setAdminUserOptions(options);
        }
    }, [adminUsers]);

    return React.useMemo(() => adminUserOptions, [adminUserOptions]);
};

export const mapAdminUsersToOptions = (adminUsers: AdminUser[]): DropdownOption[] => {
    return (adminUsers ?? [])
        .map(au => ({
            value: au.id,
            text: getUserDisplayName(au)
        }))
        .sort((a, b) => a.text.localeCompare(b.text));
};
